import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import SendPanelWithRequestNoteWidget from '../../../widgets/sendPanelWithRequestNoteWidget/SendPanelWithRequestNoteWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getOpenBankAccount, downloadOpenBankAccountFile } from '../../../redux/actions/contract'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { Message } from 'rsuite'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'

export default function SendApproveBankAccount() {
  //เสนออนุมัติเปิดบัญชีสำหรับเบิกจ่าย
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  const mockSchema = {
    header: 'เสนออนุมัติเปิดบัญชีสำหรับเบิกจ่าย',
    subHeader: null,
    forms: {
      requestNote: {
        header: 'เสนออนุมัติเปิดบัญชีสำหรับเบิกจ่าย',
        buttonText: 'เสนออนุมัติเปิดบัญชีสำหรับเบิกจ่าย',
        note: {
          name: 'note',
          label: 'แสดงความคิดเห็น',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาแสดงความคิดเห็น',
            },
          ],
        },
      },
    },
  }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getOpenBankAccount(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetFile = async (id) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadOpenBankAccountFile(id)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets
            showCommandButton={true}
            formSchema={schema.forms.agreementDetails}
          />
        )}

        {schema?.forms?.requestNote?.note && (
          <SendPanelWithRequestNoteWidget
            showCommandButton={!schema.forms.requestNote.disabled}
            schema={schema?.forms?.requestNote}
            isOpenBankAccount={true}
          />
        )}

        {!schema?.forms?.disablePreview && (
          <div>
            {isPdfError ? (
              <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
            ) : (
              <PdfRenderWidgets
                header={'หนังสือขอเปิดบัญชีเงินฝากธนาคาร'}
                file={previewPdf}
                isLoading={isLoadingPDF}
                fileName={'หนังสือขอเปิดบัญชีเงินฝากธนาคาร'}
                onReload={() => {
                  handleGetFile(projectId)
                }}
                loadingMessage={
                  'กรุณารอสักครู่ ระบบกำลังสร้าง PDF หนังสือขอเปิดบัญชีเงินฝากธนาคาร...'
                }
                firstExpandToReload={true}
              />
            )}
          </div>
        )}
        <br />
      </SidebarProposal>
    </>
  )
}
